import React from "react";
import { HashRouter as Router, Routes, Route } from "react-router-dom";
import Login from "../pages/Auth/Login";
import PrivateRoute from "./PrivateRoutes";
import Dashboard from "../pages/Dashboard";
import Customers from "../pages/Customers";
import Plans from "../pages/Plans";
import Records from "../pages/Records";
import CronManagement from "../pages/CronManagement";
import Home from "../pages/Home";
import VencimientoTreinta from "../pages/VencimientoTreinta";
import UsersCustomers from "../pages/UsersCustomers";
import Users from "../pages/Users";
import UserSessions from "../pages/UserSessions";

function AppRoute () {
  return (
      <Router>
        <Routes>
          <Route exact path="/login" element={ <Login /> } />
          <Route exact path="/" element={ <PrivateRoute><Dashboard /></PrivateRoute> } />
          <Route exact path="/dashboard" element={ <PrivateRoute><Dashboard /></PrivateRoute> } />
          <Route exact path="/cron-management" element={ <PrivateRoute><CronManagement /></PrivateRoute> } />
          <Route exact path="/reports" element={ <PrivateRoute><Records /></PrivateRoute> } />
          <Route exact path="/renovation/ten-days" element={ <PrivateRoute><Home /></PrivateRoute> } />
          <Route exact path="/renovation/thirty-days" element={ <PrivateRoute><VencimientoTreinta /></PrivateRoute> } />
          <Route exact path="/plans" element={ <PrivateRoute><Plans /></PrivateRoute> } />
          <Route exact path="/customers" element={ <PrivateRoute><Customers /></PrivateRoute> } />
          <Route exact path="/users-customers" element={ <PrivateRoute><UsersCustomers /></PrivateRoute> } />
          <Route exact path="/users" element={ <PrivateRoute><Users /></PrivateRoute> } />
          <Route exact path="/security/sessions" element={ <PrivateRoute><UserSessions /></PrivateRoute> } />
        </Routes>
      </Router>
  );
}

export default AppRoute;
